module.exports = function loadJS(src, callback) {
  var script = document.createElement('script')
  script.src = src
  script.onload = callback
  document.head.appendChild(script)
}



//////////////////
// WEBPACK FOOTER
// ./~/time-input-polyfill/core/helpers/loadJS.js
// module id = 853
// module chunks = 0